import React from 'react';
import { AuthRoles } from "components/auth";

export const LoanOpeningIncomesConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/loan_opening_incomes`,
      component: React.lazy(() => import('./LoanOpeningIncomes'))
    }
  ]
};